import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Loading } from '@/components/ui/loading';
import { redirectToSSOLogin } from '@/lib/sso';

interface SSORedirectPageProps {
  returnTo?: string;
}

export const SSORedirectPage: React.FC<SSORedirectPageProps> = ({ returnTo }) => {
  const location = useLocation();

  useEffect(() => {
    redirectToSSOLogin(returnTo || `${window.location.origin}${location.pathname}${location.search}${location.hash}`);
  }, [location, returnTo]);

  return <Loading text="Đang chuyển đến đăng nhập..." description="Bạn sẽ được chuyển sang hệ thống SSO" />;
};
